import type { UserProfileResponse } from '../dtos/user-profile.dto'
import { adamoApi } from '../../api/adamo-api'
import { logInfo, logSessionSnapshot } from '../utils/sso-logger'

export async function fetchUserProfile(): Promise<UserProfileResponse> {
  logInfo('fetchUserProfile — calling GET /api/v1/user/profile (cookies)')
  logSessionSnapshot('before fetchUserProfile')

  const response = await adamoApi.get<UserProfileResponse>('/api/v1/user/profile')

  logInfo('fetchUserProfile — success', {
    message: response.data.message,
    profileUuid: response.data.data?.uuid,
    profileEmail: response.data.data?.email,
    permissionsCount: response.data.data?.permissions?.length,
    allowedProducts: response.data.data?.allowedProducts
  })

  return response.data
}
